import { initializeApp, getApps, getApp } from 'firebase/app'
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
  Auth,
} from 'firebase/auth'

export const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY || 'AIzaSyD9YsMrCXpOxd8r-ieM40uGy5_u7BHBmLE',
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN || 'mamf-slides.firebaseapp.com',
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID || 'mamf-slides',
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET || 'mamf-slides.firebasestorage.app',
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID || '285966344323',
  appId: process.env.GATSBY_FIREBASE_APP_ID || '1:285966344323:web:6d8f9a790886a921543bb6',
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID || 'G-JKDX1341XR',
}

export const getFirebaseApp = () => {
  if (typeof window === 'undefined') return null
  return getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
}

let authInstance: Auth | null = null

export const getFirebaseAuth = (): Auth | null => {
  if (typeof window === 'undefined') return null
  if (!authInstance) {
    const app = getFirebaseApp()
    if (!app) return null
    authInstance = getAuth(app)

    // Enforce local persistence so the user stays signed in across reloads
    setPersistence(authInstance, browserLocalPersistence).catch((err) => {
      console.warn('Failed to set browserLocalPersistence on Firebase Auth:', err)
    })
  }
  return authInstance
}

export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({
  prompt: 'select_account',
})

export const getAllowedEmailDomains = (): string[] => {
  const envVal = process.env.GATSBY_ALLOWED_EMAIL_DOMAINS
  if (envVal) {
    return envVal
      .split(',')
      .map((d) => d.trim().toLowerCase())
      .filter(Boolean)
  }
  return ['mamf.pl', 'meandmyfriends.com']
}

export const ADMIN_EMAILS = [
  'jakub.nagiet@mamf.pl',
  'jakub.nagiet@meandmyfriends.com',
]

export const isAllowedEmailDomain = (email: string | null | undefined): boolean => {
  if (!email) return false
  const lower = email.trim().toLowerCase()
  const atIndex = lower.lastIndexOf('@')
  if (atIndex === -1) return false
  const domain = lower.substring(atIndex + 1)
  const allowed = getAllowedEmailDomains()
  return allowed.includes(domain)
}
